import { render, staticRenderFns } from "./DataloggerRemote.vue?vue&type=template&id=468811c0&scoped=true&"
import script from "./DataloggerRemote.vue?vue&type=script&lang=ts&"
export * from "./DataloggerRemote.vue?vue&type=script&lang=ts&"
import style0 from "./DataloggerRemote.vue?vue&type=style&index=0&id=468811c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468811c0",
  null
  
)

export default component.exports